import { render, staticRenderFns } from "./AgendaDestinatarios.vue?vue&type=template&id=2797f66c&"
import script from "./AgendaDestinatarios.vue?vue&type=script&lang=js&"
export * from "./AgendaDestinatarios.vue?vue&type=script&lang=js&"
import style0 from "./AgendaDestinatarios.vue?vue&type=style&index=0&id=2797f66c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports